import { getFontSize, getFontWeight } from '../../../foundation/theme/typography.utils';
import tokens from '../../../foundation/tokens/js/tokens';
// Constants.
// -----------------------------------------------------------------------------
/** Default disabled */
export const SWITCH_DEFAULT_DISABLED = false;
/** Default mode. */
export const SWITCH_DEFAULT_MODE = 'light';
/** Default on value. */
export const SWITCH_DEFAULT_ON = false;
/** Default role. */
export const SWITCH_DEFAULT_ROLE = 'none';
/** Default size. */
export const SWITCH_DEFAULT_SIZE = 's';
/** Scale mappings. */
export const MAPPINGS_SCALE = {
    s: {
        fontSize: getFontSize('s'),
        fontWeight: getFontWeight('medium')
    },
    xs: {
        fontSize: getFontSize('xs'),
        fontWeight: getFontWeight('medium')
    }
};
/** Mapping: mode. */
export const MAPPINGS_MODE = {
    // Dark.
    dark: {
        background: tokens.colors.black[100].value,
        border: tokens.colors.midnight[800].value,
        dot: tokens.colors.midnight[800].value,
        disabled: {
            background: tokens.colors.midnight[900].value,
            border: tokens.colors.midnight[850].value,
            dot: tokens.colors.midnight[850].value,
            checked: tokens.colors.midnight[900].value
        },
        focus: {
            background: tokens.colors.midnight[850].value,
            shadow: tokens.colors.midnight[150].value,
            checkedBackground: tokens.colors.midnight[200].value,
            checkerBorder: tokens.colors.midnight[800].value
        },
        hover: {
            border: tokens.colors.midnight[400].value,
            dot: tokens.colors.midnight[400].value
        },
        checked: {
            background: tokens.colors.midnight[200].value,
            border: tokens.colors.midnight[800].value,
            dot: tokens.colors.midnight[800].value,
            hoverBackground: tokens.colors.midnight[600].value,
            hoverBorder: tokens.colors.midnight[600].value,
            hoverDot: tokens.colors.midnight[200].value
        }
    },
    // Light.
    light: {
        background: tokens.colors.midnight[150].value,
        border: tokens.colors.midnight[200].value,
        dot: tokens.colors.midnight[200].value,
        disabled: {
            background: tokens.colors.midnight[100].value,
            border: tokens.colors.midnight[150].value,
            dot: tokens.colors.midnight[150].value,
            checked: tokens.colors.midnight[100].value
        },
        focus: {
            background: tokens.colors.midnight[150].value,
            shadow: tokens.colors.midnight[150].value,
            checkedBackground: tokens.colors.midnight[800].value,
            checkerBorder: tokens.colors.midnight[800].value
        },
        hover: {
            border: tokens.colors.midnight[400].value,
            dot: tokens.colors.midnight[400].value
        },
        checked: {
            background: tokens.colors.midnight[800].value,
            border: tokens.colors.midnight[800].value,
            dot: tokens.colors.midnight[200].value,
            hoverBackground: tokens.colors.midnight[600].value,
            hoverBorder: tokens.colors.midnight[600].value,
            hoverDot: tokens.colors.midnight[200].value
        }
    }
};
//# sourceMappingURL=Switch.constants.js.map